import { AccessTime, FilterList, Email } from '@mui/icons-material';
import { BenefitBullet } from '../types/landing';

export const benefitBullets: BenefitBullet[] = [
  { icon: AccessTime, text: 'Save 14+ hours weekly' },
  { icon: FilterList, text: 'Never miss what matters' },
  { icon: Email, text: 'Delivered to your inbox' },
];
